/**
 * APP BOOTSTRAP — runs once from `index.ts`.
 */
import { Application } from '@integro/core';
import { set } from 'lodash-es';
import { AttachmentsHelper } from './helpers/attachments';
import { registerGridFormatters } from './grid-formatters';
import { appHelpers } from './helpers';
import { LazyTabManager } from './utils';

export function initialize(app: Application) {
  const attachmentsHelper = new AttachmentsHelper(app);

  set(app, 'attachments', attachmentsHelper);
  set(app, 'helpers', appHelpers);

  set(app, 'utils', {
    LazyTabManager,
  });

  registerGridFormatters(attachmentsHelper);
}
